const ChangePhoneNumberLine = {
  ValidationErrors: {
    InvalidAreaCode:
      "Please enter your area code as a number. Don't include any spaces or dashes.",
    InvalidPhoneNumber:
      "Please complete your phone number. Don't include any spaces or dashes.",
    GenericError: "Sorry, there was a problem updating your number."
  },
  DeleteConfirmTooltip: "Are you sure you want to delete this number?"
};

export default ChangePhoneNumberLine;
